import { baseApi } from './baseApi';

const toQuery = (filter = {}) => {
  const p = new URLSearchParams();
  Object.entries(filter).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const consultationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listConsultations: build.query({
      query: (filter) => `/consultations${toQuery(filter)}`,
      transformResponse: (resp) => resp.data,
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map((c) => ({ type: 'Consultation', id: c.id })),
              { type: 'Consultation', id: 'LIST' },
            ]
          : [{ type: 'Consultation', id: 'LIST' }],
    }),
    getConsultation: build.query({
      query: (id) => `/consultations/${id}`,
      transformResponse: (resp) => resp.data,
      providesTags: (_r, _e, id) => [{ type: 'Consultation', id }],
    }),
    createConsultation: build.mutation({
      query: (body) => ({ url: '/consultations', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      // Scheduling a consultation also moves the lead — refresh leads + dashboard.
      invalidatesTags: [
        { type: 'Consultation', id: 'LIST' },
        { type: 'Lead', id: 'LIST' },
        'Dashboard',
      ],
    }),
    updateConsultationStatus: build.mutation({
      query: ({ id, status, cancellationReason }) => ({
        url: `/consultations/${id}/status`,
        method: 'PATCH',
        body: { status, cancellationReason },
      }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Consultation', id },
        { type: 'Consultation', id: 'LIST' },
        { type: 'Lead', id: 'LIST' },
      ],
    }),
    // Planned-action notes — multiple free-text entries per consultation row.
    addConsultationActionNote: build.mutation({
      query: ({ id, text }) => ({ url: `/consultations/${id}/action-notes`, method: 'POST', body: { text } }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Consultation', id }, { type: 'Consultation', id: 'LIST' },
      ],
    }),
    deleteConsultationActionNote: build.mutation({
      query: ({ id, noteId }) => ({ url: `/consultations/${id}/action-notes/${noteId}`, method: 'DELETE' }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Consultation', id }, { type: 'Consultation', id: 'LIST' },
      ],
    }),
    updateConsultationStage: build.mutation({
      query: ({ id, stage }) => ({
        url: `/consultations/${id}/stage`,
        method: 'PATCH',
        body: { stage },
      }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Consultation', id },
        { type: 'Consultation', id: 'LIST' },
      ],
    }),
    recordConsultationOutcome: build.mutation({
      query: ({ id, ...body }) => ({ url: `/consultations/${id}/outcome`, method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Consultation', id },
        { type: 'Consultation', id: 'LIST' },
        { type: 'Lead', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useListConsultationsQuery,
  useGetConsultationQuery,
  useCreateConsultationMutation,
  useUpdateConsultationStatusMutation,
  useUpdateConsultationStageMutation,
  useRecordConsultationOutcomeMutation,
  useAddConsultationActionNoteMutation,
  useDeleteConsultationActionNoteMutation,
} = consultationsApi;
